import * as React from 'react';
import BasicBubble from './components/BasicBubble';
import Style from './style';
const DEFAULT_PROPS = {
    type: 'left',
    customStyle: {},
    needScale: false
};
export class Bubble extends React.PureComponent {
    constructor(props) {
        super(props);
        this.style = new Style(props.needScale);
    }
    render() {
        const data = Object.assign(Object.assign({}, DEFAULT_PROPS), this.props);
        const { type } = data;
        const defaultStyles = this.style.getStyle();
        const { text, customStyle, anglePosition } = data;
        const { backgroundColor, color, borderColor, borderWidth } = customStyle || {};
        const extraStyle = backgroundColor
            ? { backgroundColor }
            : {};
        if (borderColor) {
            extraStyle.borderColor = borderColor;
            extraStyle.borderWidth = borderWidth || 1;
        }
        const extraTextStyle = color ? { color } : {};
        const extraAngleStyle = backgroundColor
            ? {
                borderTopColor: backgroundColor,
                borderBottomColor: backgroundColor
            }
            : {};
        let basicStyle = defaultStyles.bubbleLeftStyle;
        let wrapperStyle = {};
        let textStyle = {};
        let angleStyle = {};
        let topAngle = false;
        let bottomAngle = false;
        switch (type) {
            case 'right': {
                basicStyle = defaultStyles.bubbleRightStyle;
                break;
            }
            case 'topLeft': {
                anglePosition && (extraAngleStyle.left = anglePosition);
                basicStyle = defaultStyles.bubbleTopLeftStyle;
                angleStyle = Object.assign(Object.assign({}, basicStyle.angleStyle), extraAngleStyle);
                bottomAngle = true;
                break;
            }
            case 'topCenter': {
                basicStyle = defaultStyles.bubbleTopCenterStyle;
                angleStyle = Object.assign(Object.assign({}, basicStyle.angleStyle), extraAngleStyle);
                bottomAngle = true;
                break;
            }
            case 'topRight': {
                anglePosition && (extraAngleStyle.right = anglePosition);
                basicStyle = defaultStyles.bubbleTopRightStyle;
                angleStyle = Object.assign(Object.assign({}, basicStyle.angleStyle), extraAngleStyle);
                bottomAngle = true;
                break;
            }
            case 'bottomLeft': {
                anglePosition && (extraAngleStyle.left = anglePosition);
                basicStyle = defaultStyles.bubbleBottomLeftStyle;
                angleStyle = Object.assign(Object.assign({}, basicStyle.angleStyle), extraAngleStyle);
                topAngle = true;
                break;
            }
            case 'bottomCenter': {
                basicStyle = defaultStyles.bubbleBottomCenterStyle;
                angleStyle = Object.assign(Object.assign({}, basicStyle.angleStyle), extraAngleStyle);
                topAngle = true;
                break;
            }
            case 'bottomRight': {
                anglePosition && (extraAngleStyle.right = anglePosition);
                basicStyle = defaultStyles.bubbleBottomRightStyle;
                angleStyle = Object.assign(Object.assign({}, basicStyle.angleStyle), extraAngleStyle);
                topAngle = true;
                break;
            }
            case 'notice': {
                if (text) {
                    basicStyle = defaultStyles.bubbleNoticeStyle;
                }
                else {
                    basicStyle = defaultStyles.bubbleSmallNoticeStyle;
                }
                break;
            }
            default:
                break;
        }
        wrapperStyle = Object.assign(Object.assign({}, basicStyle.wrapperStyle), extraStyle);
        textStyle = Object.assign(Object.assign({}, basicStyle.textStyle), extraTextStyle);
        return (<BasicBubble wrapperStyle={wrapperStyle} textStyle={textStyle} angleStyle={angleStyle} text={text} topAngle={topAngle} bottomAngle={bottomAngle}/>);
    }
}
